import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BlogIcon,
  CardPlusIcon,
  CommentsIcon,
  ThumbsUpIcon,
} from '../../assets/svg/SVGComponents';
import PrimaryButton from '../Buttons/PrimaryButton';
import {
  Container,
  Content,
  Description,
  EmptyPostProject,
  EmptyTimeline,
  Header,
  LikesandComents,
  PostProject,
  ProjectItem,
  SocialSection,
  Timeline,
  TimelineSection,
  TitlePanel,
  UserProjectHighlighted,
  UserProjectSection,
} from './styles';
import { IPostProjectProps } from '../../dtos/IPostProjectProps';
import LoadingComponent from './LoadingComponent';
import PostThumbnail from '../PostThumbnail';

// import { Container } from './styles';
interface ICommunityComponentProps {
  project_user_highlighted?: IPostProjectProps[];
  feed_posts?: IPostProjectProps[];
  isLoading: boolean;
  onProjectClick?: (projectId: string) => void;
}

const CommunityPanel: React.FC<ICommunityComponentProps> = ({
  project_user_highlighted,
  feed_posts,
  isLoading,
  onProjectClick,
}) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = React.useState(false);
  const componentRef = React.useRef<HTMLDivElement>(null);
  const hasAnimated = React.useRef(false);
  const [projectUserHighlighted, setProjectUserHighlighted] = React.useState<
    IPostProjectProps | undefined
  >();
  const [posts, setPosts] = React.useState<IPostProjectProps[] | undefined>();

  useEffect(() => {
    if (!isLoading) {
      // Pequeno atraso para garantir que o DOM foi renderizado com os dados
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 100);

      return () => clearTimeout(timer);
    }
    return undefined;
  }, [isLoading]);

  useEffect(() => {
    if (project_user_highlighted && project_user_highlighted.length > 0) {
      setProjectUserHighlighted(project_user_highlighted[0]);
    } else {
      setProjectUserHighlighted(undefined);
    }
  }, [project_user_highlighted, feed_posts]);
  useEffect(() => {
    if (feed_posts && feed_posts.length > 0) {
      setPosts(feed_posts.slice(0, 3));
    }
  }, [feed_posts]);

  if (isLoading) {
    return (
      <Container>
        <LoadingComponent />
      </Container>
    );
  }

  const handleProjectClick = (projectId: string, e: React.MouseEvent): void => {
    if (onProjectClick) {
      e.preventDefault();
      onProjectClick(projectId);
    }
  };

  return (
    <Container ref={componentRef}>
      <Header>
        <div className="header-comunity">
          <TitlePanel>
            <BlogIcon
              width="2rem"
              stroke="#FF9800"
              strokeWidth={2}
              fill="none"
            />
            <h1>Comunidade</h1>
          </TitlePanel>
          <span>Veja o que comunidade está compartilhando.</span>
        </div>
        <PrimaryButton
          onClick={() => {
            navigate('/community');
          }}
        >
          Visitar Comunidade
        </PrimaryButton>
      </Header>
      <Content>
        <UserProjectSection>
          {projectUserHighlighted && (
            <UserProjectHighlighted
              onClick={e => handleProjectClick(projectUserHighlighted.id, e)}
              role="button"
              tabIndex={0}
              className={isVisible ? 'fade-in' : 'hidden'}
            >
              <p>O seu post está sendo bastante visto na comunidade!</p>
              <PostProject>
                <PostThumbnail
                  photos={projectUserHighlighted.photos}
                  alt={projectUserHighlighted.title}
                />
                <LikesandComents>
                  <div>
                    <ThumbsUpIcon
                      width="2.2rem"
                      stroke="#f2f2f2"
                      strokeWidth={2}
                    />
                    <span>{projectUserHighlighted.likes}</span>
                  </div>
                  <div>
                    <CommentsIcon
                      width="2.2rem"
                      stroke="#f2f2f2"
                      strokeWidth={2}
                    />
                    <span>{projectUserHighlighted.comments_count}</span>
                  </div>
                </LikesandComents>
              </PostProject>
            </UserProjectHighlighted>
          )}
          {!projectUserHighlighted && (
            <EmptyPostProject className={isVisible ? 'fade-in' : 'hidden'}>
              <img
                src="https://fuzzyplaydev.s3.us-east-2.amazonaws.com/illustration+clean/card-empty-user-projects.jpg"
                alt="projeto-default"
              />
              <PrimaryButton
                onClick={() => {
                  navigate('/create/post');
                }}
              >
                <CardPlusIcon
                  width="1.6rem"
                  stroke="#FFffff"
                  strokeWidth={2}
                  fill="none"
                />
                Publicar Projeto
              </PrimaryButton>
              <p>
                Publique seu projeto e entre na comunidade <br /> Fuzzy Makers!
              </p>
            </EmptyPostProject>
          )}
        </UserProjectSection>
        <TimelineSection>
          <h2> Dê uma olhada nesses novos projetos:</h2>
          <Timeline>
            {posts && posts.length > 0 ? (
              posts.map((post, index) => (
                <ProjectItem
                  key={post.id}
                  onClick={e => handleProjectClick(post.id, e)}
                  role="button"
                  tabIndex={0}
                  className={isVisible ? `fade-in delay-${index}` : 'hidden'}
                >
                  <PostThumbnail photos={post.photos} alt={post.title} />
                  <Description>
                    <h3>{post.title}</h3>
                    <p>{post.description}</p>
                    <SocialSection>
                      <div>
                        <ThumbsUpIcon
                          fillArmColor="#fff"
                          fillHandColor="#fff"
                          width="1.6rem"
                          stroke="#323232"
                          strokeWidth={2}
                        />
                        <span>{post.likes}</span>
                      </div>
                      <div>
                        <CommentsIcon
                          width="1.6rem"
                          stroke="#323232"
                          strokeWidth={2}
                        />
                        <span>{post.comments_count}</span>
                      </div>
                    </SocialSection>
                  </Description>
                </ProjectItem>
              ))
            ) : (
              <EmptyTimeline className={isVisible ? 'fade-in' : 'hidden'}>
                <BlogIcon
                  width="3rem"
                  stroke="#bdbdbd"
                  strokeWidth={1.5}
                  fill="none"
                />
                <p>Ainda não há projetos na comunidade.</p>
                <PrimaryButton
                  onClick={() => {
                    navigate('/create/post');
                  }}
                >
                  <CardPlusIcon
                    width="1.4rem"
                    stroke="#fff"
                    strokeWidth={2}
                    fill="none"
                  />
                  Seja o primeiro a publicar!
                </PrimaryButton>
              </EmptyTimeline>
            )}
          </Timeline>
        </TimelineSection>
      </Content>
    </Container>
  );
};

export default CommunityPanel;
